import React from "react";

const OrderPage: React.FC = () => {
  return <div>OrderPage</div>;
};

export default OrderPage;
